<template>
  <b-modal size="sm" button-size="sm" hide-footer v-model="showModal" @hidden="cancelar" :title="title">
    <b-form @submit.prevent="save">
      <b-card>
        <b-form-row>
          <lg-form-input invalidFeedback="Informe uma compensação válida!" description=" " :error="$v.form.compensacao"
            v-model="form.compensacao" label="Cód.Compensação:*" cols="12" sm="12" md="12" />
          <lg-form-input invalidFeedback="Informe uma sigla válida!" description=" " :error="$v.form.sigla"
            v-model="form.sigla" label="Sigla:*" cols="12" sm="12" md="12" />

          <lg-form-input invalidFeedback="Informe um nome válida!" description=" " :error="$v.form.nome"
            v-model="form.nome" label="Nome:*" cols="12" sm="12" />
          <b-form-group label="Status:*" class="ml-3">
            <b-form-radio-group v-model="form.situacao" :options="statusOptions" size="sm"
              name="status-inline"></b-form-radio-group>
          </b-form-group>

        </b-form-row>
        <b-form-row>


          <b-col cols="3"></b-col>
          <b-col cols="6" class="text-center">
            <b-button id="salvarLocalCadastro" class=" my-2" size="sm" pill variant="success" @click="save">
              <b-icon icon="check-circle" />
              <b-tooltip target="salvarLocalCadastro" title="Salvar"></b-tooltip>

            </b-button>

            <b-button id="cancelarLocalCadastro" class=" my-2 ml-2" size="sm" pill variant="danger" @click="cancelar">
              <b-icon icon="x-circle" />
              <b-tooltip target="cancelarLocalCadastro" title="Cancelar"></b-tooltip>

            </b-button>
          </b-col>
        </b-form-row>
      </b-card>
    </b-form>
  </b-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { FormResourceMixin } from "@/core/mixins/resource";

export default {
  components: {
    LgFormInput,
  },
  props: {
    isModal: Boolean,
    id: Number,
    prefix: {
      type: Array,
      default: () => []
    },
  },
  mixins: [FormResourceMixin],
  validations: {
    form: {
      nome: { required },
      compensacao: { required },
      sigla: { required },
      situacao: { required },
    },
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, this.id == null ? "Cadastro" : "Alteração"]
    },
    title() {
      return this.updatedPrefix.join(" > ")
    }
  },
  data() {
    return {
      statusOptions: [
        { text: "Ativo", value: 1 },
        { text: "Inativo", value: 0 },
      ],

      showModal: true,
      form: {
        situacao: null,
      },
    };
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/banco`);
  },
  async mounted() {
    if (this.id) {
      const { data } = await this.$service.findById(this.id);
      this.form = data;
    } else {
      this.form.situacao = 1;
    }
  },

  methods: {
    cancelar() {
      this.$emit("close");
    },
    async save() {
      if (!this.formIsValid) {
        this.$v.$touch();
        this.$notify({
          type: "danger",
          message: "Verifique os campos do cadastro.",
        });
        return;
      }

      this.$service.save(this.form).then(() => {
        this.$notify({
          type: "success",
          message: "Registro salvo com sucesso",
        });

        this.cancelar();

      }).catch(() => {
        this.$notify({
          type: "danger",
          message: "Este registro já está cadastrado",
        });

      });

    },
  },
};
</script>
